"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDev = exports.Platform = exports.Environment = exports.Project = exports.US_APP_LINK = exports.UK_SUPPORT_EMAIL = exports.BR_SUPPORT_EMAIL = exports.US_SUPPORT_EMAIL = exports.UK_SUPPORT_PHONE = exports.BR_SUPPORT_PHONE = exports.US_SUPPORT_PHONE = exports.VALID_DOC_EXTENSION = exports.MAX_FILE_SIZE = exports.MAX_DESCRIPTION_LENGTH = exports.MIN_DESCRIPTION_LENGTH = exports.MAX_TITLE_LENGTH = exports.MIN_TITLE_LENGTH = exports.MIN_PAGES = exports.MAX_PAGES = exports.WORDS_PER_PAGE = void 0;
exports.WORDS_PER_PAGE = 275;
exports.MAX_PAGES = 363;
exports.MIN_PAGES = 1;
exports.MIN_TITLE_LENGTH = 4;
exports.MAX_TITLE_LENGTH = 110;
exports.MIN_DESCRIPTION_LENGTH = 10;
exports.MAX_DESCRIPTION_LENGTH = 20000;
exports.MAX_FILE_SIZE = 15000000;
exports.VALID_DOC_EXTENSION = `.doc,.docx,.xls,.xlsx,.rtf,.odt,.txt,.jpg,.png,.gif,.frw,.cdw,.m3d,.a3d,.zip,.rar,.pdf,.pptx,.ppt,.jpeg,.dwg,.xlsm`;
exports.US_SUPPORT_PHONE = '1-855-407-7728';
exports.BR_SUPPORT_PHONE = '+55 11 4680-2890';
exports.UK_SUPPORT_PHONE = '+44-2045-772372';
exports.US_SUPPORT_EMAIL = 'support@studybay.com';
exports.BR_SUPPORT_EMAIL = 'suporte@mystudybay.com.br';
exports.UK_SUPPORT_EMAIL = 'support@studybayhelp.co.uk';
exports.US_APP_LINK = 'https://app.adjust.com/ch01bt2';
var Project;
(function (Project) {
    Project["sb"] = "sb";
    Project["br"] = "br";
    Project["cs"] = "cs";
    Project["uk"] = "uk";
})(Project || (exports.Project = Project = {}));
var Environment;
(function (Environment) {
    Environment["dev"] = "dev";
    Environment["prod"] = "prod";
})(Environment || (exports.Environment = Environment = {}));
var Platform;
(function (Platform) {
    Platform["mobileWeb"] = "Mobile Web";
    Platform["desktopWeb"] = "Desktop Web";
    Platform["tabletWeb"] = "Tablet Web";
    Platform["web"] = "Web";
})(Platform || (exports.Platform = Platform = {}));
exports.isDev = typeof window === 'undefined' ? true : (document.location.host.includes('dev') || document.location.host.includes('test') || document.location.host.includes('localhost'));
